import { useState } from 'react';
import { API_OPTIONS } from '../../utils/constants';

interface ApiResponse<T> {
  data: T | null;
  isLoading: boolean;
  error: string | null;
  hasMore: boolean;
}

type FetchFunction = (url: string) => Promise<void>;

const useFetch = <T,>(): [FetchFunction, ApiResponse<T>] => {
  const [response, setResponse] = useState<ApiResponse<T>>({
    data: null,
    isLoading: false,
    error: null,
    hasMore: true,
  });

  const fetchData: FetchFunction = async (url) => {
    setResponse({ ...response, isLoading: true });
    try {
      const fetchedData = await fetch(url, API_OPTIONS);
      if (!fetchedData.ok) {
        throw new Error('Network response was not ok');
      }
      const result = await fetchedData.json();
      setResponse({
        data: result,
        isLoading: false,
        error: null,
        hasMore: result.page < result.total_pages,
      });
    } catch (error) {
      setResponse({
        ...response,
        isLoading: false,
        error: 'An error occurred',
      });
    }
  };

  return [fetchData, response];
};

export default useFetch;
